// Moved from `src/hooks/mutation/useMutateRevertReverseTrial.ts` (now a
// delegate) at D2, ARCFE-972 — severed by the ratified ARCFE-921 mechanism.
//
// What could NOT move, and why the ports exist:
//   - `toast` (×2) and `useTranslations` — a user-visible effect is an app
//     reaction; intl and copy live app-side (packages/CLAUDE.md).
//   - `invalidateCurrentUser` / `invalidateCurrentUserBillingInfo` — these are
//     app-side `/data` invalidators. `invalidateCurrentUser` belongs to
//     workspace's identity family and `invalidateCurrentUserBillingInfo` to
//     the billing surface that has not transferred yet (D3), and `/data` may
//     never import a foreign `/data`. So the success port fires where they
//     fired and the delegate calls both, in the same order.
//
// The measured "these hooks depend on useQueryUserBillingInfo" blocker is
// therefore NOT a data dependency at all — it is a cache-invalidation call.
// Naming that distinction is what let this hook move ahead of D3 instead of
// waiting behind the billing transfer.

import { useMutation } from '@tanstack/react-query';
import { revertReverseTrial } from '../api/trials';

export type UseMutateRevertReverseTrialProps = {
  /** Fires where the two invalidators + the success toast fired. */
  onRevertSuccess?: () => void;
  /** Fires where `logger.error` + the destructive toast fired. */
  onRevertError?: (error: unknown) => void;
};

/**
 * POST /user/revert-reverse-trial.
 *
 * The legacy hook took a `trialType` argument used for NOTHING but choosing
 * the toast description, so it does not cross into the package: the delegate
 * keeps the parameter and the branch, and this hook stays unaware of it.
 */
export function useMutateRevertReverseTrial({
  onRevertSuccess,
  onRevertError,
}: UseMutateRevertReverseTrialProps = {}) {
  return useMutation({
    mutationFn: async () => {
      await revertReverseTrial();
    },
    onSuccess: () => {
      onRevertSuccess?.();
    },
    onError: (error) => {
      onRevertError?.(error);
    },
  });
}
